<template>
	<div>
		<base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
		</base-header>

		<div class="container-fluid mt--7">
			<div class="row">
				<div class="col-md-12 order-xl-1">
					<div class="alert alert-success alert-dismissible fade show" role="alert" v-if="success">
						<span class="alert-icon"><i class="ni ni-like-2"></i></span>
						<span class="alert-text"><strong>Success!</strong> Your info has been updated!</span>
						<button type="button" class="close" data-dismiss="alert" @click.prevent="success = false;" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<card shadow type="secondary">
						<div slot="header" class="bg-white border-0">
							<div class="row align-items-center">
								<div class="col-8">
									<h3 class="mb-0">My account</h3>
								</div>
								<div class="col-4 text-right">
									<a @click.prevent="save" class="btn btn-sm btn-primary text-white">Save</a>
									<!--<a href="#!" class="btn btn-sm btn-danger">Reset</a>-->
								</div>
							</div>
						</div>
						<template>
							<form @submit.prevent="save">
								<h6 class="heading-small text-muted mb-4">User information</h6>
								<div class="pl-lg-4">
									<div class="row">
										<div class="col-lg-6">
											<base-input alternative=""
														label="Email address"
														placeholder="jesse@example.com"
														input-classes="form-control-alternative"
														v-model="user.email"
											/>
										</div>
										<div class="col-lg-6">
											<base-input alternative=""
														label="Name"
														placeholder="Name"
														input-classes="form-control-alternative"
														v-model="user.name"
											/>
										</div>
									</div>
								</div>
								<hr class="my-4" />
								<!-- Address -->
								<h6 class="heading-small text-muted mb-4">Organization Information</h6>
								<div class="pl-lg-4">
									<div class="row">
										<div class="col-md-12">
											<base-input alternative=""
														label="Corporation / Legal Name"
														placeholder="Organization Name"
														input-classes="form-control-alternative"
														v-model="organization.name"
														:readonly="user.organizationId"
											/>
										</div>
									</div>
									<div class="row">
										<div class="col-md-12">
											<base-input alternative=""
														label="Address"
														placeholder="Address"
														input-classes="form-control-alternative"
														v-model="organization.address"
											/>
										</div>
									</div>
									<div class="row">
										<div class="col-lg-4">
											<base-input alternative=""
														label="City"
														placeholder="City"
														input-classes="form-control-alternative"
														v-model="organization.city"
											/>
										</div>
										<div class="col-lg-4">
											<base-input alternative=""
														label="State"
														placeholder="State"
														input-classes="form-control-alternative"
														v-model="organization.state"
											/>
										</div>
										<div class="col-lg-4">
											<base-input alternative=""
														label="Postal code"
														placeholder="Postal code"
														input-classes="form-control-alternative"
														v-model="organization.zipCode"
											/>
										</div>
									</div>
								</div>
								<hr class="my-4" />
								<!-- Description -->
								<h6 class="heading-small text-muted mb-4">Credentials</h6>
									<div class="form-group">
										<div class="row">
											<div class="col-md-6">
												<base-input placeholder="••••••••••••"
													label="New Password" type="password" v-model="updatePassword">
												</base-input>
											</div>
											<div class="col-md-6">
												<base-input placeholder="••••••••••••"
													label="Confirm New Password" type="password" v-model="confirmPassword">
												</base-input>
											</div>
										</div> 
										<template v-if="organization._id">
											<hr class="my-4" />
											<div class="row">
												<div class="col-md-12" v-if="apiKey">
													<base-input label="API Key" type="text" v-model="apiKey" readonly></base-input>
												</div>
											</div>
											<div class="row">
												<div class="col-md-12">
													<base-button type="success" block @click.prevent="createAPIKey" v-if="!apiKey">Create API Key</base-button>
													<base-button type="danger" block @click.prevent="removeAPIKey" v-else>Delete API Key</base-button>
												</div>
											</div>
										</template>
									</div>
							</form>
						</template>
					</card>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'user-profile',
	data() {
		return {
			organization: {},
			updatePassword: '',
			confirmPassword: '',
			apiKey: false,
			success: false
		}
	},
	computed: {
		user () {
			return this.$store.getters["auth/user"];
		},
		Organization () {
			const { Organization } = this.$FeathersVuex.api;
			return Organization;
		},
		APIKey () {
			const { APIKey } = this.$FeathersVuex.api;
			return APIKey;
		}
	},
	methods: {
		async save () {
			this.success = false;
			if (this.updatePassword.length && (this.updatePassword === this.confirmPassword)) {
				this.user.password = this.updatePassword;
			}
			if (this.organization.name) {
				await this.organization.save();
				this.user.setupOrganization = true;	
			}
			await this.user.save();
			this.success = true;
			this.updatePassword = this.confirmPassword = '';
		},
		async createAPIKey () {
			this.$store.dispatch('api-keys/create', {}).then(res => {
				this.apiKey = res.apiKey;
				this.user.setupApiKey = true;
				this.user.save();
			});
		},
		async removeAPIKey () {
			await this.$store.dispatch('api-keys/remove', this.apiKey);
			this.apiKey = false;
		},
		renderAPIKey () {
			this.$store.dispatch('api-keys/find', {}).then(res => {
				if (res.data.length) {
					this.apiKey = res.data[0].apiKey;
				}
			});
		}
	},
	async mounted () {
		const organization = await this.Organization.find({ query: { userId: this.user._id } });
		if (organization.total > 0) {
			this.organization = organization.data[0];
			this.renderAPIKey();
		} else {
			this.organization = new this.Organization;
		}
	}
};
</script>
<style></style>
